import { Environment } from '../../../environment';
import { v4 as uuidv4 } from 'uuid';
import { Api } from '../axioscadastro';

export interface IListagemFabricas {
  idfabrica: string;
  nome: string;
  logo: string;
  multiplo: string;
}     
export interface IDetalheFabricas {
  nome: string;     
  grupo: number;
  arquivo: string;
  logo?: string;
  multiplo: number;
}
type TotalCount = {
    data: IListagemFabricas[];
    totalCount: number;
}
const getAlllist = async (id = '', filter = ''): Promise<TotalCount | Error> => {
  try {
    const urlRelativa: string = id === '' ?  `/fabricas?limit=${Environment.LIMITE_DE_LINHAS}&filter=${filter}` : `/fabricaslist/${id}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };}
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }};
const getAll = async (page = 1, filter = ''): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/fabricas?page=${page}&limit=${Environment.LIMITE_DE_LINHAS}&filter=${filter}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };}
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }};
const getById = async (id: string): Promise<IDetalheFabricas | Error> => {
  try {
    const { data } = await Api.get(`/fabricas/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }};
const create = async (dados: IDetalheFabricas): Promise<string | Error> => {
  try {
    const guuid = uuidv4();
    const { data } = await Api.post<IDetalheFabricas>('/fabricas',  {idfabrica: guuid, ...dados});
    if (Object.keys(data).length === 0) {
      return guuid;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao criar o registro.');
  }};
const updateById = async (id: string, dados: IDetalheFabricas): Promise<void | Error> => {
  try {
    await Api.put(`/fabricas/${id}`, dados);
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }};
const updateByIdImg = async (id: string, imge: File | undefined): Promise<void | Error> => {
  try {
    if (imge) {
      const formData = new FormData();
      formData.append('file', imge || ''); 
      await Api.put(`/fabricaimg/${id}`, formData);
      return;
    }
    return new Error('Erro ao Atualizar Foto.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao Atualizar Foto.');
  }};
const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/fabricas/${id}`);
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao apagar o registro.');
  }
};
export const FabricasService = {
  getAll,
  getAlllist,
  create,
  getById,
  updateById,
  deleteById,
  updateByIdImg,
};